module.exports = __webpack_public_path__ + "img/SES_180420005.c0da09e6.jpg";